// extracted by mini-css-extract-plugin
module.exports = {"title":"_404_title_YU7yQ"};